import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, FormControl, InputLabel, TextField, Select, MenuItem, Button, Stack, 
    TableCell, tableCellClasses, styled, IconButton, Toolbar, AppBar, Dialog, Snackbar, } from "@mui/material";
import { Search, Edit, InsertDriveFileOutlined, InfoOutlined, PrintOutlined, IosShareOutlined, Close, RemoveCircleOutline } from '@mui/icons-material';
import Header from "../ui/Header";
import { API } from "../../conf";
import { Context } from "../../App";
import pdfMake from "pdfmake/build/pdfmake";
import {recu_content} from "../../asset/pdfmaker";
import moment from 'moment';
import pdfFonts from "pdfmake/build/vfs_fonts";
import SorTableCheckable from "../ui/sortable-checkable";
import RegistFond from "../../pages/register-fond";
import DonHistory from "../sections/don-history";
import SendRecuForm from "../forms/send-recu-form";
import { host } from "../../conf";
import lg from '../../asset/pictures/logo_pdf.png';
import band from '../../asset/pictures/header_ban_color.png';
import Graph from "../ui/graph";
import { useNavigate } from "react-router-dom";
import CancelDon from "../forms/cancelDon";

pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

export default function JrnDon() {
    const { updateConnect } = useContext(Context)
    const navigate = useNavigate()
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')

    const editCol = {header: "", sortable: false, row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'220px'}} >
        <IconButton aria-label="modifier" onClick={()=>{setDon(row); manage_dialog(true, 'edit')}} disabled={(row.is_verse&&agent.level<3)||row.is_cloture}><Edit fontSize="small"/></IconButton>
        <IconButton aria-label="Edit reçu" onClick={()=>get_recu([row])}><InsertDriveFileOutlined fontSize="small"/></IconButton>
        <IconButton aria-label="imprimer" onClick={()=>print_recu([row])}><PrintOutlined fontSize="small"/></IconButton>
        <IconButton aria-label="partager" onClick={()=>{setDon(row); setLoad(true); create_recu([row]).then(pdf_url=>{setPdf(pdf_url);setLoad(false); manage_dialog(true, 'share')})}}><IosShareOutlined fontSize="small"/></IconButton>
        <IconButton aria-label="informations complémentaires" onClick={()=>{setDon(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
        {(!row.is_cloture||agent.level>2)&&!row.isVerse&&<IconButton aria-label="annulation" onClick={()=>{setDon(row); checkCancelable(row)}}><RemoveCircleOutline fontSize="small"/></IconButton>}
    </StyledTableCell>}
    const columns = (donats) => [
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><StyledTableCell key={index}>{moment.utc(row.date).format('DD/MM/YYYY')}</StyledTableCell>},
        {header: "Donateur", sortable: true, sortBy:(el)=>{const donat= donats?.find(dt=>dt.num===el.donateur); return (donat?.nom+' '+donat?.prenom1+' '+donat?.prenom2).toLowerCase()}, 
            row: (row, index)=>{const donat= donats.find(dt=>dt.num===row.donateur); return <StyledTableCell key={index} align="center" sx={{minWidth:'150px', textTransform:'capitalize'}}>{donat?.genre+' '+donat?.nom+' '+donat?.prenom1+' '+donat?.prenom2}</StyledTableCell>}},
        {header: "Dîme", sortable: true, sortBy:(el)=>el.dime, row: (row, index)=><StyledTableCell key={index} align="center">{row.dime.toFixed(2)}€</StyledTableCell>},
        {header: "Offrande globale", sortable: true, sortBy:(el)=>el.offrande_globale, row: (row, index)=><StyledTableCell key={index} align="center">{row.offrande_globale.toFixed(2)}€</StyledTableCell>},
        {header: "Offrandes spécifiées FEAM", sortable: false, row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'200px'}}>{row.offrande_spe_feam.map((off, index)=><Typography fontSize={14} key={index}>{off.libelle+': '+off.montant.toFixed(2)}€</Typography>)}</StyledTableCell>},
        {header: "Offrandes spécifiées église", sortable: false, row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'200px'}}>{row.offrande_spe_eglise.map((off, index)=><Typography fontSize={14} key={index}>{off.libelle+': '+off.montant.toFixed(2)}€</Typography>)}</StyledTableCell>},
        {header: "Montant total", sortable: true, sortBy:(el)=>el.dime+el.offrande_globale+el.offrande_spe_feam.concat(el.offrande_spe_eglise).reduce((total, off)=>total+off.montant, 0), 
            row: (row, index)=><StyledTableCell key={index} align="center">{(row.dime+row.offrande_globale+row.offrande_spe_feam.concat(row.offrande_spe_eglise).reduce((total, off)=>total+off.montant, 0)).toFixed(2)}€</StyledTableCell>},
        {header: "N° reçu", sortable: true, sortBy:(el)=>el.recu_num, row: (row, index)=><StyledTableCell key={index} align="center" sx={{minWidth:'100px'}} >{row.recu_num}</StyledTableCell>},
        {header: "Utilisateur", sortable: true, sortBy:(el)=>el.creator, row: (row, index)=><StyledTableCell key={index} align="center" sx={{minWidth:'120px', textTransform:'capitalize'}} >{row.creator}</StyledTableCell>},
    ]
    const montant_columns = [
        {header: "Dîme", search:(el)=>el.dime.toFixed(2)},
        {header: "Offrande globale", search:(el)=>el.offrande_globale.toFixed(2)},
        {header: "Offrandes spécifiées FEAM", search:(el)=>el.offrande_spe_feam.reduce((total, current)=>total+current.montant.toFixed(2)+' ', '')},
        {header: "Offrandes spécifiées église", search:(el)=>el.offrande_spe_eglise.reduce((total, current)=>total+current.montant.toFixed(2)+' ', '')},
        {header: "Montant total", search:(el)=>el.dime+el.offrande_globale+el.offrande_spe_feam.concat(el.offrande_spe_eglise).reduce((total, off)=>total+off.montant, 0).toFixed(2)},
    ]
    const [selectedCol, setSelectCol] = useState(["Date", "Donateur", "Dîme", "Offrande globale", "Offrandes spécifiées FEAM", "Offrandes spécifiées église"])
    const [selectedMCol, setSelectMCol] = useState(["Dîme"])
    const [loading, setLoad] = useState(true)
    const [min_date, setMin] = useState()
    const [max_date, setMax] = useState()
    const [start_date, setStart] = useState('')
    const [end_date, setEnd] = useState('')
    const [search_input, setSearch] = useState('')
    const [montant, setMontant] = useState('')
    const [open, setOpen] = useState(false)
    const [open_snack, setsnack] = useState(false)
    const [dons, setDons] = useState()
    const [don, setDon] = useState()
    const [donators, setDonators] = useState()
    const [pdf, setPdf] = useState()
    const [open_dialog, setDialog] = useState(false)
    const [action, setAction] = useState('')
    const [table, setTable] = useState([])
    const [selectItems, setItems] = useState([])
    const [snack_msg, setmsg] = useState('')
    
    const eglise = useMemo(()=>{
        if (organisation && organisation.type==='église') {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    function manage_dialog(open, action='') {
        setDialog(open)
        setAction(action)
    }

    function create_recu(d) { return new Promise((resolve, reject) => {
        const dons = JSON.parse(JSON.stringify(d))
        
        fetch(API.concat(`/eglises/by/${JSON.stringify({number:{$in:[...new Set(dons.map(don=>don.eglise))]}})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                const eglises = response.status === 200 ? await response.json():[]
                var content = [];

                dons.forEach((don, index) => {
                    const donator = donators.find(dt=> dt.num===don.donateur)
                    const eglise = eglises.find(eg=> eg.number===don.eglise)
                    don.donateur = donator?.genre+' '+donator?.nom+' '+donator?.prenom1+' '+donator?.prenom2
                    don.eglise = eglise?.nom+' ('+eglise?.commune+')'
                    content.push(recu_content(don));

                    // Ajoutez une rupture de page après chaque 'don', sauf le dernier
                    if (index < dons.length - 1) {
                        content.push({ text: ' ', pageBreak: 'after' });
                    }
                });
                const pdfDocGenerator = pdfMake.createPdf({
                    pageSize: 'A5',
                    pageOrientation: 'landscape',
                    pageMargins: [ 30, 20, 120, 15 ],
                    header: function(currentPage, pageCount, pageSize) { return {stack: [
                        {
                            image:band,
                            width: 1,
                            height:pageSize.height,
                            absolutePosition: {x: pageSize.width-100, y: 0}
                        },
                        {
                            image:'logo',
                            width: 70,
                            height:70,
                            absolutePosition: {x: pageSize.width-85, y: 15}
                        },
                    ]}},
                    images: {
                        logo: `${host}${lg}`
                    },
                    content: content, 
                    styles:{
                        header_footer: {fontSize:8, bold: true},
                        header: {fontSize:16, bold: true},
                        light_header: {fontSize:14},
                        subheader: {fontSize:14, bold: true},
                        tableHeader: {bold: true},
                        tableTotal: {bold: true, color: '#fff'}
                    },
                    defaultStyle:{fontSize: 10}        
                });
                pdfDocGenerator.getBlob((blob) => {
                    resolve(URL.createObjectURL(blob))
                });
            }
        })
    })}

    function get_recu(don) {
        setLoad(true)
        create_recu(don).then(pdf_url=>{
            setPdf(pdf_url)
            manage_dialog(true, 'recu'); setLoad(false)
        })
    }

    function print_recu(dons) {
        setLoad(true)
        create_recu(dons).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = function() {
                win.print();
                };
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    function get_lineargraph_data() {
        const selected = dons.filter(don=> selectItems.includes(don._id))
        const dates = [...new Set(selected.map(don=>don.date))]
        let data = [
            {label:"Dîme", values: dates.map(date => dons.filter(don=> don.date===date).reduce((tt,cdon)=>tt+cdon.dime, 0))},
            {label:"Offrande globale", values: dates.map(date => dons.filter(don=> don.date===date).reduce((tt,cdon)=>tt+cdon.offrande_globale, 0))},
            {label:"Offrandes spécifiées FEAM", values: dates.map(date => dons.filter(don=> don.date===date).reduce((tt,cdon)=>tt+cdon.offrande_spe_feam.reduce((ttosf, off)=>ttosf+off.montant,0), 0))},
            {label:"Offrandes spécifiées église", values: dates.map(date => dons.filter(don=> don.date===date).reduce((tt,cdon)=>tt+cdon.offrande_spe_eglise.reduce((ttosf, off)=>ttosf+off.montant,0), 0))},
        ]
        return {dates, data}
    }

    async function checkCancelable(row) {
        setLoad(true)
        fetch(API.concat('/versements/by'), {
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify({dons: row.num})
        }).then(async response=>{
            setLoad(false)
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    if (json.length > 0) {
                        const versement = json[0]
                        if (versement.is_valid&&agent.level<3) {
                            alert('Vous ne pouvez pas annuler ce don car il est lié à un versement déjà validé.')
                            row.isVerse = true
                            setDons(old=> old.map(d=> d._id===row._id ? row : d))
                            setDon(row)
                        } else {
                            alert('Attention: ce don est lié à un versement. Si vous annulez ce don, vous devrez OBLIGATOIREMENT mettre à jour le versement correspondant: '+versement.bordereau_num)
                            manage_dialog(true, 'annulation')
                        }
                    } else {
                        // Si la pas de versement lié, on peut annuler directement
                        manage_dialog(true, 'annulation')
                    }
                } else {
                    alert('Impossible d\'annuler le don')
                }
            }
        })
    }

    function getDons(end_date, start_date) {
        setLoad(true); setItems([])

        fetch(API.concat(`/dons/by/${JSON.stringify({eglise: eglise.number, $and: [{date: {$lte: new Date(end_date).setTime(new Date(end_date).getTime()+24*60*60*1000)}}, { date: {$gte: new Date(start_date)}}]})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const sorted = await json.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    setDons(sorted)
                    fetch(API.concat(`/donateurs/by/${JSON.stringify({num:{$in:[...new Set(json.map(don=>don.donateur))]}})}`), {
                        method:'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                        }
                    }).then(async response=>{
                        const token = response.headers.get('x-auth-token')
                        if(response.status === 401) {
                            sessionStorage.clear()
                            updateConnect(false)
                        }else {
                            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                            }
                            if (response.status === 200) {
                                const dts = await response.json()
                                setDonators(dts)
                                setTable(selectedCol.map(header=> columns(dts).find(col=> col.header===header)))
                            }setLoad(false)
                        }
                    })
                }else setLoad(false)
            }
        })
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(don) {
        const donat = donators?.find(dt=> dt.num===don.donateur)
        return donat?.genre+' '+donat?.nom+' '+donat?.prenom1+' '+donat?.prenom2+' '+don.offrande_spe_feam.concat(don.offrande_spe_eglise).reduce((all, off)=> all+' '+off.libelle,'')+' '+don.recu_num
    }

    function get_Msearchable(don) {
        return selectedMCol.reduce((all, current)=> all+montant_columns.find(col=> col.header===current)?.search(don)+' ','')
    }

    useEffect(()=>{
        if (eglise&&eglise.number) {        
            fetch(API.concat(`/dons/${eglise.number}/dates/min_max`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        if(json && Object.keys(json).includes("mindate") && Object.keys(json).includes("maxdate")){
                            setMin(new Date(json.mindate))
                            setMax(new Date(json.maxdate)); setEnd(moment.utc(new Date(json.maxdate)).format('yyyy-MM-DD'))
                            const month_before = moment.utc(json.maxdate).add(-1,'month')
                            setStart(month_before.isAfter(moment.utc(json.mindate))?month_before.format('yyyy-MM-DD'):moment.utc(json.mindate).format('yyyy-MM-DD'))
                            getDons(json.maxdate, month_before.isAfter(moment.utc(json.mindate))?month_before.format('yyyy-MM-DD'):json.mindate)
                        } else {
                            setMin(new Date().getDate()>0 ? new Date(Date.now()).setDate(0) : new Date().setTime(new Date().getTime()-24*60*60*1000))
                            setMax(new Date()); setEnd(moment.utc(Date.now()).format('yyyy-MM-DD'))
                            setLoad(false)
                        }
                    }else setLoad(false)
                }
            })
        } 
    }, [updateConnect, navigate, eglise])

    useEffect(()=>{}, [table, selectedMCol])

    useEffect(()=>{
        if (organisation?.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type: {$in: ['église', 'fédération']}})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    },[agent,organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
    }));     
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Journal des Dons</Typography>
            {organisation?.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)setDons([]); return e.target.value})}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            <Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <Stack direction='row' spacing={2} sx={{alignItems:'center'}}>
                        <Typography fontWeight={600} fontSize={16}>Période:</Typography>
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'90px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de début"
                        type='date'
                        value={start_date}
                        inputProps={min_date&&max_date&&{min: new Date(min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setStart(event.target.value)
                            if (end_date!=='' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) <= 0) {
                                setEnd('')
                            } 
                        }}
                        />
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'90px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de fin"
                        type="date"
                        value={end_date}
                        inputProps={min_date&&max_date&&{min: new Date(start_date!=='' ? start_date : min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setEnd(event.target.value)
                            if (start_date!=='' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) <= 0) {
                                setStart('')
                            }
                        }}
                        />
                        <Button variant="contained" disabled={start_date===''||end_date===''||!eglise} onClick={()=>getDons(end_date, start_date)}>Appliquer</Button>
                    </Stack>
                    <Button variant="contained" sx={{ alignSelf:'center' }} onClick={()=> {manage_dialog(true, 'graph')}} disabled={!dons?.length>0|| selectItems.length<=0} >Graph</Button>
                </div>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'20px'}}>
                    <TextField
                    size="small"
                    label="Rechercher un don (par donateur, offrande spécifiée, n° reçu)"
                    disabled={!dons?.length>0}
                    sx={{width:'60%', minWidth:'300px'}}
                    value={search_input}
                    InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Search />
                          </InputAdornment>
                        ),
                    }}
                    onChange={(event)=> setSearch(event.target.value)}
                    />
                    <FormControl sx={{ m: 1, width:'30%', minWidth: '250px' }}>
                        <InputLabel>Colonnes</InputLabel>
                        <Select
                        size="small"
                        multiple
                        renderValue={(selected) => selected.join(', ')}
                        sx={{ width:'100%', minWidth:'250px', maxWidth:'500px'}}
                        label="Colonnes"
                        open={open}
                        onOpen={()=>setOpen(true)}
                        onClose={()=>setOpen(false)}
                        value={selectedCol}
                        onChange={(e)=>setSelectCol(e.target.value.flat().length>columns([]).length ? columns([]).map(col=> col.header) : e.target.value.flat())}
                        >
                            <MenuItem value={columns([]).map(col=> col.header)} sx={{justifyContent:'center'}}>
                                <Typography fontWeight='bold'>Tout sélectionner</Typography> 
                            </MenuItem>
                            {columns([]).map((col, index) => (
                                <MenuItem key={index} value={col.header}>
                                    <Typography>{col.header}</Typography> 
                                </MenuItem>
                            ))}
                            <div style={{display:'flex', justifyContent:'space-around', alignItems:'center', marginTop:8, paddingInline:'10px'}}>
                                <Button variant="outlined" sx={{ textTransform:'none', fontWeight:'400', paddingY:'1px', width:'100%', marginRight:'5px' }} onClick={()=>setSelectCol([])}>Effacer</Button>
                                <Button variant="contained" sx={{ textTransform:'none', fontWeight:'400', paddingY:'1px', width:'100%', marginLeft:'5px' }} onClick={()=>{setOpen(false); setTable(selectedCol.map(header=> columns(donators).find(col=> col.header===header)))}}>Appliquer</Button>
                            </div> 
                        </Select>
                    </FormControl>
                </div>
                <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                    <Stack direction='row' alignItems='center'>
                        <TextField
                        label="Rechercher un montant"
                        size="small"
                        type="number"
                        disabled={!dons?.length>0}
                        sx={{width:'25%', minWidth:'250px', maxWidth:'350px', marginRight:'5px'}}
                        value={montant}
                        InputProps={{
                            endAdornment: (
                            <InputAdornment position="end">
                                <Search />
                            </InputAdornment>
                            ),
                        }}
                        onChange={(event)=>{
                            if (event.target.value.split('.').length<2 || !(event.target.value.split('.')[1]?.length>2)) {
                                setMontant(event.target.value)  
                            } 
                        }}
                        />
                        <Typography variant="body1">dans</Typography>
                        <FormControl sx={{ m: 1, width:'30%', minWidth: '250px' }}>
                            <InputLabel>Champs</InputLabel>
                            <Select
                            size="small"
                            multiple
                            renderValue={(selected) => selected.join(', ')}
                            sx={{ width:'100%', minWidth:'250px', maxWidth:'500px'}}
                            label="Colonnes"
                            value={selectedMCol}
                            onChange={(e)=>setSelectMCol(e.target.value.flat())}
                            >
                                {montant_columns.map((col, index) => (
                                    <MenuItem key={index} value={col.header}>
                                        <Typography>{col.header}</Typography> 
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>

                    <Box style={{ paddingInline:'15px', border:'1px solid rgba(0,0,0,0.2)', borderRadius:4, marginRight:'7px', display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                        <Typography color='rgba(0,0,0,0.6)' fontSize={11} sx={{backgroundColor:'#fff', marginTop:'-8px', marginLeft:'-7px', paddingX:'5px'}} >Partager toute la sélection</Typography>
                        <Stack direction='row' alignItems='center' sx={{marginBottom:'15px', marginTop:'8px'}}>
                            <Button variant="contained" disabled={selectItems.length<=0} sx={{ textTransform:'none', fontWeight:'400', paddingY:'1px', width:'100%', marginRight:'5px' }} onClick={()=>{print_recu(dons.filter(don=>selectItems.includes(don._id)))}}>Impression</Button>
                            <Button variant="contained" disabled={selectItems.length<=0} sx={{ textTransform:'none', fontWeight:'400', paddingY:'1px', width:'100%', marginLeft:'5px' }} onClick={()=>{setLoad(true); setDon(selectItems); create_recu(dons.filter(don=>selectItems.includes(don._id))).then(pdf_url=>{setPdf(pdf_url);setLoad(false); manage_dialog(true, 'share_many')})}}>Envoyer</Button>
                        </Stack>
                    </Box> 
                </div>
                
                {dons && <SorTableCheckable data={dons.filter(log=> normalize(get_searchable(log)).includes(normalize(search_input))&&(montant?.length>0&&selectedMCol.toString()!==''&&selectedMCol.toString()!==' ' ? get_Msearchable(log).includes(montant): true))} selectItems={selectItems} setItems={setItems} table={table.concat([editCol])} rowsPerPage={50} rowsPerPageOptions={[10, 25, 50, 100, 300]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>

            <Dialog fullScreen={action==='edit'} open={open_dialog} onClose={()=>{setDon(); manage_dialog(false) ; setPdf()}} maxWidth={action==='annulation'?'xs':'md'} fullWidth PaperProps={action!=='edit'?{sx : {overflow: 'hidden'}}:{}} >
                <IconButton sx={{position:'absolute', top:'5px', right:'5px'}} onClick={()=>{manage_dialog(false) ; setDon(); setPdf()}}><Close/></IconButton>
                {action==='recu' && pdf && <embed src={pdf} width='100%' height='600px' type="application/pdf" />}
                {action==='edit' && don && <>
                    <AppBar sx={{ position: 'fixed' }} color="grey">
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Modification
                        </Typography>
                        <Button color="inherit" onClick={()=>{manage_dialog(false) ; setDon()}}>
                        Fermé
                        </Button>
                    </Toolbar>
                    </AppBar>

                    <RegistFond {...{edit:true, don, setDons, total:don.dime+don.offrande_globale+don.offrande_spe_feam.concat(don.offrande_spe_eglise).reduce((total, off)=>total+off.montant, 0), close:()=>{setDialog(false); setAction(false); setDon()}}} />
                </>}
                {action==='info' && don && <DonHistory {...{eglise, don}} />}
                {action==='share' && don && pdf && <SendRecuForm ismany={false} dons={[don._id]} donators={[don.donateur]} recu={pdf} snackbar={(msg)=> {setsnack(true); setmsg(msg)}} close={()=> {setDialog(false); setDon(); setAction(''); setPdf()}}/>}
                {action==='share_many' && don && pdf && <SendRecuForm ismany={true} dons={don} donators={[...new Set(don.map(don=>don.donateur))]} recu={pdf} snackbar={(msg)=> {setsnack(true); setmsg(msg)}} close={()=> {setDialog(false); setDon(); setAction(''); setPdf()}}/>}
                {action==='graph' && <Graph data={[
                    {label:"Dîme", value: selectItems.reduce((tt, current)=>tt+dons.find(don=> don._id===current).dime,0)},
                    {label:"Offrande globale", value: selectItems.reduce((tt, current)=>tt+dons.find(don=> don._id===current).offrande_globale,0)},
                    {label:"Offrandes spécifiées FEAM", value: selectItems.reduce((tt, current)=>tt+dons.find(don=> don._id===current).offrande_spe_feam.reduce((ttosf, off)=>ttosf+off.montant,0),0)},
                    {label:"Offrandes spécifiées église", value: selectItems.reduce((tt, current)=>tt+dons.find(don=> don._id===current).offrande_spe_eglise.reduce((ttosf, off)=>ttosf+off.montant,0),0)},
                ]}
                tt_label="Global"
                line_data = {get_lineargraph_data()}/>}
                {action==='annulation' && don && <CancelDon {...{don, setLoad, 
                    updateDons: () => setDons(old => old.filter(d => d._id !== don._id )), onCancel:() => manage_dialog(false)}}/>}
            </Dialog>

            <Snackbar
            open={open_snack}
            autoHideDuration={5000}
            onClose={()=> setsnack(false)}
            message={snack_msg}
            />
        </div>
    )
}